var cov_1wds30znee = function () {
  var path = "/Users/spana/SHEIN/shineout/src/TreeSelect/index.ts",
      hash = "1786fa75a854914a8a9084ef9cbe69f4366d129f",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/TreeSelect/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 25
        },
        end: {
          line: 20,
          column: 13
        }
      },
      "1": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 51
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import inputable from '../Form/inputable';
import { compose } from '../utils/func';
import inputBorder from '../hoc/inputBorder';
import { treeSelectClass } from './styles';
import TreeSelect from './TreeSelect';
import filter from './filter';
import datum from './datum';
import tiled, { advancedFilterHOC } from './tiled';
import absolute from '../Table/context';
var exportTreeSelect = (cov_1wds30znee.s[0]++, compose(inputable, inputBorder({
  className: treeSelectClass('_'),
  tag: 'div'
}), datum, advancedFilterHOC, filter, tiled({}), absolute)(TreeSelect));
cov_1wds30znee.s[1]++;
exportTreeSelect.displayName = 'ShineoutTreeSelect';
export default exportTreeSelect;